import instance from "@/services/api";

export const getMenu = async () => {
  return await instance().get('/common/menu/read/').then(res => res?.data)
}